import {makeClient} from '@roundforest/ga-commons'
import {makeClient as makeFakeClient} from '@roundforest/ga-commons/fake'
import {type LDFlagSet} from 'launchdarkly-node-server-sdk'
import {calculateObjectHash} from '../calculate-object-hash'

const context = window?.__remixContext
const loaderData = context?.state?.loaderData
const rootDataContext = loaderData?.root

export const getABTests = (featureFlags: LDFlagSet) =>
  Object.fromEntries(Object.entries(featureFlags || {}).filter(([key]) => key?.startsWith('AB_')))

function makeGoogleAnalyticsClient(): ReturnType<typeof makeClient> {
  const abTestFlags = getABTests(rootDataContext?.featureFlags)
  return makeClient(window?.gtag, {
    fullUrl: window.location.href,
    referrer: rootDataContext?.referrerUrl,
    pageLoadId: rootDataContext?.pageLoadIdCookie,
    userTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    timezoneOffset: new Date().getTimezoneOffset(),
    abTestFlags,
    abTestsHash: calculateObjectHash(abTestFlags),
    featureFlags: rootDataContext?.featureFlags,
    ffHash: calculateObjectHash(rootDataContext?.featureFlags),
    convKey: rootDataContext?.googleAdsKey,
    convId: rootDataContext?.googleAdsId,
    labels: {stack_version: 'brg-remix'},
    remarketingPropertyId: rootDataContext?.googleAdsRemarketingKey,
    experimentPropertyId: rootDataContext?.googleAnalyticsMeasurementId,
  })
}
export const gaClient = process.env.NODE_ENV === 'production' ? makeGoogleAnalyticsClient() : makeFakeClient()
